import { render, staticRenderFns } from "./CoachManagerStatusSector.vue?vue&type=template&id=4625c2b4&scoped=true"
import script from "./CoachManagerStatusSector.vue?vue&type=script&lang=js"
export * from "./CoachManagerStatusSector.vue?vue&type=script&lang=js"
import style0 from "./CoachManagerStatusSector.vue?vue&type=style&index=0&id=4625c2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4625c2b4",
  null
  
)

export default component.exports